import React from 'react';
import {AccentColorOptions} from 'epic-ue-theme';
import {Typography, VerticalSpacer} from '../..';

export interface LicenseTitleDescriptionProps {
    ref?: React.ForwardedRef<HTMLDivElement>;
    className?: string;
    accentColor?: AccentColorOptions;
    title?: string;
    description?: string;
    height?: string;
}

export const LicenseTitleDescription = React.forwardRef(
    (props: LicenseTitleDescriptionProps, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => {
        const {className, title, description, accentColor, height} = props;

        return (
            <div
                ref={ref}
                className={`${className || ''} License-title-description`}
                style={{height: height || 'initial'}}>
                <VerticalSpacer variant="custom" spacing={7} downSmSpacing={5} />
                {title && (
                    <>
                        <Typography variant="h2">{title}</Typography>
                        <VerticalSpacer variant="paragraph" />
                    </>
                )}
                {description && (
                    <>
                        <Typography variant="p" accentColor={accentColor}>
                            {description}
                        </Typography>
                        <VerticalSpacer variant="custom" spacing={5} downSmSpacing={4} />
                    </>
                )}
            </div>
        );
    }
);

LicenseTitleDescription.displayName = 'LicenseTitleDescription';
